import * as React from "react";
import { Button, Modal } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { pushSizeGuideLinkClickEvent, pushBookAppointmentClickEvent } from "../../../../../../../Analytics/events/modules/Analytics/events/SizeGuideEvents.js";
import FindOutSize from "../../../../components/FindOutSize/modules/EcommContent/components/SizeGuideModal/components/FindOutSize/FindOutSize.js";
import Measure from "../../../../components/Measure/modules/EcommContent/components/SizeGuideModal/components/Measure/Measure.js";
import SizeGuide from "../../../../components/SizeGuide/modules/EcommContent/components/SizeGuideModal/components/SizeGuide/SizeGuide.js";
/* empty css                    */
const SizeGuideModalView = ({ sizeGuideContent, productName, sku }) => {
  const { getLabel } = useIntl();
  const [openModal, setOpenModal] = React.useState(false);
  if (!sizeGuideContent) {
    return null;
  }
  const {
    findOutSizeCTA,
    findOutSizeDescription,
    findOutSizeImage,
    findOutSizeSubtitle,
    findOutSizeTitle,
    measureDescription,
    measureDescriptionImage,
    measureImage,
    measureSteps,
    measureTitle,
    sizeGuideSizeCompound,
    sizeTitle
  } = sizeGuideContent;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "size-guide-modal" }, /* @__PURE__ */ React.createElement("span", { className: "size-guide-modal__title" }, getLabel("products.frameSize.title")), /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "size-guide-modal__trigger",
      variant: "ghost",
      size: "custom",
      caption: getLabel("products.frameSize.link"),
      onClick: () => {
        setOpenModal(true);
        pushSizeGuideLinkClickEvent(sku, productName);
      }
    }
  )), openModal && /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "size-guide-modal__modal",
      title: sizeTitle,
      isOpen: openModal,
      showIcon: true,
      onModalClose: () => setOpenModal(false)
    },
    /* @__PURE__ */ React.createElement("div", { className: "size-guide-modal__modal-container" }, /* @__PURE__ */ React.createElement(SizeGuide, { sizeGuideSizeCompound }), /* @__PURE__ */ React.createElement(
      Measure,
      {
        measureDescription,
        measureDescriptionImage,
        measureImage,
        measureSteps,
        measureTitle
      }
    ), /* @__PURE__ */ React.createElement(
      FindOutSize,
      {
        findOutSizeCTA,
        findOutSizeDescription,
        findOutSizeImage,
        findOutSizeSubtitle,
        findOutSizeTitle,
        pushBookAppointmentClickEvent: () => pushBookAppointmentClickEvent(sku, productName)
      }
    ))
  ));
};
export {
  SizeGuideModalView
};
//# sourceMappingURL=SizeGuideModalView.js.map
